import "./GlobalStages.module.css";
import Header from "@/reusable_sections/Header";
import QualityJourney from "./sections/QualityJourney";
import TerritorioHistorico from "./sections/TerritorioHistorico";
import GamingSocialFooter from "@/reusable_sections/Footer";
export default function GlobalStagesPage() {
  return <div>
      <Header />
      <QualityJourney />
      <TerritorioHistorico />
      <GamingSocialFooter />
    </div>;
}